import Vue from "vue";
import axios from "axios";
import NProgress from "nprogress";
import store from "../store";
import { redirectToLogin } from "../utils/helpers";
import { reportClientError } from "../utils/reportClientError";

const instance = axios.create({
    baseURL: window.location.origin.startsWith("http://localhost")
        ? "https://localhost:44307"
        : window.location.origin,
});

var progressCount = 0;

function shouldTrackProgress(config) {
    if (!config || config.progress === false) {
        return false;
    }

    var path = (window.location.pathname || "").toLowerCase();
    if (path.indexOf("/communications/inbox") !== -1) {
        return false;
    }

    return true;
}

function startProgress(config) {
    if (!shouldTrackProgress(config)) {
        return;
    }
    progressCount++;
    NProgress.start();
}

function stopProgress(config) {
    if (!shouldTrackProgress(config)) {
        return;
    }
    progressCount--;
    if (progressCount <= 0) {
        progressCount = 0;
        NProgress.done();
    }
}

async function errorHandler(error) {
    if (error.response && error.response.status == 401) {
        redirectToLogin();

        return;
    }

    console.log(error);

    if (!error.response && !(error.config && error.config.url && String(error.config.url).indexOf("logClientError") !== -1)) {
        reportClientError({
            message: error.message || "Network error",
            url: error.config && error.config.url,
            method: error.config && error.config.method,
            statusCode: "0",
        });
    }

    let text = "An error has occurred";

    // Handle blob error responses (when responseType was 'blob')
    if (error.response && error.response.data instanceof Blob) {
        try {
            const blobText = await error.response.data.text();
            const errorData = JSON.parse(blobText);
            if (typeof errorData === "string" && errorData.trim()) {
                text = errorData.trim();
            } else if (errorData) {
                text =
                    errorData.Message ||
                    errorData.message ||
                    errorData.title ||
                    blobText;
            }
        } catch (e) {
            try {
                const plain = await error.response.data.text();
                if (plain && plain.trim()) text = plain.trim();
            } catch (readError) {
                console.error("Could not parse blob error response:", e);
            }
        }
    } else if (error.response && error.response.data && error.response.data.Message) {
        text = error.response.data.Message;
    } else if (error.response && error.response.data && error.response.data.message) {
        text = error.response.data.message;
    } else if (error.response && typeof error.response.data === "string" && error.response.data) {
        text = error.response.data;
    }

    var notifyError = !(error.config && error.config.notifyError === false);
    if (notifyError) {
        Vue.notify({
            group: "notification",
            text: text,
            type: "error",
        });
    }

    throw new Error(text);
}
instance.interceptors.request.use(function(config) {
    config.headers.Authorization = store.state.authentication.token;
    startProgress(config);
    return config;
});
instance.interceptors.response.use(
    (response) => {
        stopProgress(response && response.config);
        return response ? response.data : response;
    },
    (error) => {
        stopProgress(error && error.config);
        return errorHandler(error);
    },
);

Vue.prototype.$http = instance;
